import React from 'react';
import i18next from 'i18next';

import {Button} from '@famly/mf_input_button';
import {Text} from '@famly/mf_data-display_text';
import {Box} from '@famly/mf_layout_box';

type Props = {
    type: 'button' | 'link';
    onClick: VoidFunction;
};

export const FallbackButtonToLegacyPlanEditor = ({type, onClick}: Props) => {
    return type === 'link' ? (
        <Box cursor="pointer" onClick={onClick}>
            <Text color="brandColor" variant="body" textDecoration="underline">
                {i18next.t('react.simplifiedUsBillingPlan.translations.json.fallbackButton.text')}
            </Text>
        </Box>
    ) : (
        <Box>
            <Button
                variant="secondary"
                text={i18next.t('react.simplifiedUsBillingPlan.translations.json.fallbackButton.text')}
                onClick={onClick}
            />
        </Box>
    );
};
